import api from "../api";

export interface PapelMembro {
    id: string;
    nome: string;
}

export class PapelMembroViewModel {
    static async getPapeisMembro(): Promise<PapelMembro[]> {
        const response = await api.get('/papelMembro');
        return response.data;
    }
}
